import { Grid, Group, IconButton, Layout, Page, Tab, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useStore, useToast, useModal, useAuth, usePage, useTheme, useResource } from "@/comn/hooks";
import {
    URLS,
    APIS,
    SF_BTBDMS_MGMT,
    SF_BTBDRP_MGMT,
    labelConversionMap,
} from "@/tra/tancis/ptli/ptl/btbdms/services/PtliBtbdmsService";
import { useRef, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import constants from "@/comn/constants";
import dayjs from "dayjs";

/*
 * Common Bulletin Board(Bulletin board message) Detail
 * !== 공통 게시판(게시글) 상세 ==!
 */
export const PTLI1018002Q = (): JSX.Element => {
    /*
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0001", "auth_ptli0015", "auth_ptlianyADM", "auth_ptli0019", "auth_ptli0061"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toast = useToast();
    const modal = useModal();
    const { theme } = useTheme();
    const lang = theme.lang;
    const dateFormat = constants.DATE_FORMAT_DAYJS[lang];
    const dateTimeFormat = constants.DATETIME_FORMAT_DAYJS[lang];
    const { bltbrdUuid: bltbrdUuid } = useParams(); // Bulletin board ID
    const { btbdmsId: btbdmsId } = useParams(); // Bulletin board Message ID
    const searchParams = new URLSearchParams(window.location.search);

    const rpSize = searchParams.get("rpSize"); // Number of replies (only crossed from the list when using replies) !== 답글 개수(답글사용여부일때만 목록에서 넘어옴) ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const [bltbrdInfo, setBltbrdInfo] = useState<bltbrd>(); // Bulletin board Management Info!== 게시판 관리정보 ==!
    const [ppupYn, setPpupYn] = useState<boolean>(false); // Selected pop-up status radio button !== 선택한 팝업여부 라디오버튼 ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const [btbdrpList, setBtbdrpList] = useState<btbdrp[]>([]); // Bulletin board Reply List Management state !== 답글 목록 관리 State ==!
    const [formState, setFormState] = useState<boolean[]>([]); // Management each form Bulletin board Reply editable state !== 답글 각 Form의 수정가능 여부 관리 State ==!
    const [modifyIdx, setModifyIdx] = useState<number>(-1); // Save reply temporarily save index when you click the Reply Save button !== 답글 저장버튼 클릭시 index 임시저장 ==!
    const [btbdcmCn, setBtbdcmCn] = useState<String>(); //  Main Post - Comment Content !== 메인글 - 댓글 내용 ==!
    const [btbdcmList, setBtbdcmList] = useState<btbdcm[]>([]); // Main Post - Bulletin board Comment List Management state !== 메인글 - 댓글 목록 관리 State ==!
    const [btbdcmCnByRp, setBtbdcmCnByRp] = useState<String[]>([]); //  Reply - Comment Content !== 답글 - 댓글 내용 ==!
    const [btbdcmListByRp, setBtbdcmListByRp] = useState<btbdcm[][]>([]); // Reply - Comment List Management state !== 답글 - 댓글 목록 관리 State ==!
    const [subCategory, setSubCategory] = useState<SubCategoryItem[]>([]);
    const [aprvStatCd, setAprvStatCd] = useState<String>();

    const isBmsMstrUser = useRef(false);
    useResource({
        defaultSchema: [{ area: "orgz" }, { area: "cstmOfcrCd" }, { area: "comnCd", comnCd: "COM0055" }],
    });

    type SubCategoryItem = {
        comnCd: string;
        uprCdVldVal: string;
    };

    // Bulletin board Interface !== 게시판 ==!
    interface bltbrd {
        bltbrdUuid: string;
        bltbrdKoNm: string;
        bltbrdEngNm: string;
        bltbrdTzNm: string;
        btbdrpUseYn: string;
        btbdcmUseYn: string;
        btbdrpBtbdcmUseYn: string;
        ppupSettPsblYn: string;
        atcmUseYn: string;
        atcmUpldLmtNo: Number;
        atcmCapcLmtYn: string;
        atcmLmtCapc: number;
        secrtBtbdmsUseYn: string;
        selcCntUseYn: string;
        chgYn: string;
        btbdmsSelcExuseYn: string;
        btbdrpSelcExuseYn: string;
        btbdrpSttsUseYn: string;
        relaBltbrdUseYn: string;
        btbdmsTpCdValList: any;
        reLaBltbrdList: any;
    }

    // Bulletin board Reply Interface !== 댓글 ==!
    interface btbdcm {
        btbdmsId: string;
        btbdcmCn: string;
        btbdcmSeq: string;
        frstRegstId: string;
        frstRgsrDtm: string;
        editMode: boolean;
    }

    // Bulletin board Reply Interface !== 답글 ==!
    interface btbdrp {
        bltbrdUuid: string;
        btbdmsTtleNm: string;
        btbdmsCn: string;
        btbdmsId: string;
        uprBtbdmsId: string;
        frstRegstId: string;
        frstRgsrDtm: string;
    }

    const form = {
        originBtbdms: useForm({
            defaultSchema: SF_BTBDMS_MGMT,
            defaultValues: { ...pgeStore?.form },
        }),
        btbdrpList: [
            {
                btbdrp: useForm({
                    defaultSchema: { ...SF_BTBDRP_MGMT, id: `form_btbdrp0` },
                    defaultValues: { ...pgeStore?.form },
                }),
            },
        ],
    };

    let index = 1;
    for (index; index < Number(rpSize) + 1; index++) {
        form.btbdrpList.push({
            btbdrp: useForm({
                defaultSchema: { ...SF_BTBDRP_MGMT, id: `form_btbdrp${index}` },
                defaultValues: { ...pgeStore?.form },
            }),
        });
    }

    const fetch = {
        // get Bulletin board Message Information !== 게시글 정보 조회==!
        getBtbdmsInfo: useFetch({
            api: () => APIS.getBtbdmsInfoFromQ(bltbrdUuid, btbdmsId),
            onSuccess: (data: any) => {
                const apiBrdInfo = data.resultMap.content.bltbrdInfo;
                const apiPostInfo = data.resultMap.content.btbdmsInfo;
                isBmsMstrUser.current = data.resultMap.content.isBmsMstrUser || false;
                setAprvStatCd(apiPostInfo.aprvStatCd);
                if (apiPostInfo.delYn === "Y") {
                    modal.openModal({
                        content: "msg.ptl.00694", // Abnormal access. !== 비정상 접근입니다. ==!
                        onCancel: () => {
                            navigate(`${URLS.ptli1018001q}?menuId=${menuId}&bltbrdUuid=${bltbrdUuid}`);
                        },
                    });
                }

                // Managing bulletin board management information as state !== 게시판 관리정보 State로 관리 ==!
                setBltbrdInfo({
                    bltbrdUuid: apiBrdInfo.bltbrdUuid,
                    bltbrdKoNm: apiBrdInfo.bltbrdKoNm,
                    bltbrdEngNm: apiBrdInfo.bltbrdEngNm,
                    bltbrdTzNm: apiBrdInfo.bltbrdTzNm,
                    btbdrpUseYn: apiBrdInfo.btbdrpUseYn,
                    btbdcmUseYn: apiBrdInfo.btbdcmUseYn,
                    btbdrpBtbdcmUseYn: apiBrdInfo.btbdrpBtbdcmUseYn,
                    ppupSettPsblYn: apiBrdInfo.ppupSettPsblYn,
                    atcmUseYn: apiBrdInfo.atcmUseYn,
                    atcmUpldLmtNo: apiBrdInfo.atcmUpldLmtNo,
                    atcmCapcLmtYn: apiBrdInfo.atcmCapcLmtYn,
                    atcmLmtCapc: apiBrdInfo.atcmLmtCapc,
                    secrtBtbdmsUseYn: apiBrdInfo.secrtBtbdmsUseYn,
                    selcCntUseYn: apiBrdInfo.selcCntUseYn,
                    btbdmsSelcExuseYn: apiBrdInfo.btbdmsSelcExuseYn,
                    btbdrpSelcExuseYn: apiBrdInfo.btbdrpSelcExuseYn,
                    btbdrpSttsUseYn: apiBrdInfo.btbdrpSttsUseYn,
                    relaBltbrdUseYn: apiBrdInfo.relaBltbrdUseYn,
                    btbdmsTpCdValList: apiBrdInfo.bltbrdTpCdList,
                    reLaBltbrdList: apiBrdInfo.reLaBltbrdList,
                    chgYn: apiBrdInfo.chgYn,
                });

                const newOption = data.resultMap.content.btbdrpSttsList.map((obj: any) => ({
                    label: obj.cdVldValNm,
                    value: obj.cdVldVal,
                }));
                form.originBtbdms.setSchema("btbdrpSttsCd", {
                    type: "select",
                    options: newOption,
                });

                // Dynamic Form Setting
                if (!comnUtils.isEmpty(apiBrdInfo.bltbrdTpCdList)) {
                    apiBrdInfo.bltbrdTpCdList.map((obj: any, index: any) => {
                        const isCode = obj.btbdmsTpCdValList[0]?.usrDefnVldVal1?.includes("COMI");
                        form.originBtbdms.setSchema(`btbdmsTpCd-${obj.btbdmsTpCd}-0`, {
                            label:
                                labelConversionMap.find((item) => item.comnCd === obj.usrDefnVldVal1)?.label ||
                                obj.btbdmsTpCdNm,
                            type: "select",
                            required: false,
                            ...(!isCode && {
                                options: obj.btbdmsTpCdValList.map((innerObj: any) => ({
                                    label: innerObj.cdVldValNm,
                                    value: innerObj.cdVldVal,
                                })),
                            }),
                            ...(obj.btbdmsTpCdValList[0]?.usrDefnVldVal1 === "COMI_CSTM_ORGZ_M" && {
                                area: "orgz",
                                type: "code",
                                label: "L_CSTM_SCTN",
                            }),
                            ...(obj.btbdmsTpCdValList[0]?.usrDefnVldVal1 === "COMI_USR_M" && {
                                area: "cstmOfcrCd",
                                type: "code",
                                label: "L_CHPN",
                            }),
                        });
                        obj.btbdmsTpCdValList.map((secondObj: any, index: any) => {
                            if (secondObj.subCategoryInfo) {
                                form.originBtbdms.setSchema(
                                    `btbdmsTpCd-${obj.btbdmsTpCd}-${secondObj.subCategoryInfo.uprCdVldVal}`,
                                    {
                                        label:
                                            labelConversionMap.find(
                                                (item) => item.comnCd === secondObj.subCategoryInfo?.comnCd,
                                            )?.label || secondObj.subCategoryInfo.cdVldValNm,
                                        type: "select",
                                        options: secondObj.subCategoryInfo.btbdmsTpCdValList.map(
                                            (thirdInnerObj: any) => ({
                                                label: thirdInnerObj.cdVldValNm,
                                                value: thirdInnerObj.cdVldVal,
                                            }),
                                        ),
                                    },
                                );
                            }
                        });
                    });
                }
                if (apiBrdInfo.atcmUpldLmtNo === 1) {
                    form.originBtbdms.setSchema("fileGrpUuid", { multiple: false });
                }
                if (apiBrdInfo.ppupSettPsblYn === "Y" && bltbrdUuid === "1860dd0c-b283-7cde-e063-020011ac3197") {
                    form.originBtbdms.setSchema("ppupYn", { label: "L_PUBL_FILE_YN" });
                }
                // Data Setting
                form.originBtbdms.setValues(apiPostInfo);
                if (!comnUtils.isEmpty(apiPostInfo.btbdmsTpCdValList)) {
                    apiPostInfo.btbdmsTpCdValList.map((obj: any, index: any) => {
                        form.originBtbdms.setValue(
                            `btbdmsTpCd-${obj.btbdmsTpCd}-${obj.uprCdVldVal}`,
                            obj.btbdmsTpCdVal,
                        );
                        if (obj.uprCdVldVal != 0) {
                            let newSubCategory = [...subCategory];
                            let index = newSubCategory.findIndex((item) => item.comnCd === obj.comnCd);
                            if (index > -1) {
                                newSubCategory[index] = { comnCd: obj.comnCd, uprCdVldVal: obj.uprCdVldVal };
                            } else {
                                newSubCategory.push({ comnCd: obj.comnCd, uprCdVldVal: obj.uprCdVldVal });
                            }
                            setSubCategory(newSubCategory);
                        }
                    });
                }
                if (apiPostInfo.ppupYn === "Y") {
                    if (bltbrdUuid === "1860dd0c-b283-7cde-e063-020011ac3197") {
                        setPpupYn(false);
                    } else {
                        setPpupYn(true);
                    }
                }

                form.originBtbdms.setValue("bltbrdUuid", apiBrdInfo.bltbrdUuid);
                form.originBtbdms.setSchema("btbdmsTtleNm", { required: false });
                form.originBtbdms.setValue("btbdrpSttsCd", apiPostInfo.btbdrpSttsCd);
                form.originBtbdms.setEditable(false);

                // Comment Data Setting !== 댓글 정보 세팅 ==!
                if (apiBrdInfo.btbdcmUseYn === "Y" && apiPostInfo.btbdcmList.length !== 0) {
                    const newBtbdcmList = apiPostInfo.btbdcmList.map((obj: any, index: number) => ({
                        btbdcmSeq: obj.btbdcmSeq,
                        btbdcmCn: obj.btbdcmCn,
                        btbdmsId: obj.btbdmsId,
                        frstRegstId: obj.frstRegstId,
                        frstRgsrDtm: obj.frstRgsrDtm,
                        editMode: false,
                    }));
                    setBtbdcmList(newBtbdcmList);
                }

                // Reply Data Setting !== 답글 정보 세팅 ==!
                if (apiBrdInfo.btbdrpUseYn === "Y" && apiPostInfo.btbdrpList.length !== 0) {
                    const newBtbdrpList = apiPostInfo.btbdrpList.map((obj: any, index: number) => ({
                        bltbrdUuid: obj.bltbrdUuid,
                        btbdmsTtleNm: obj.btbdmsTtleNm,
                        btbdmsCn: obj.btbdmsCn,
                        btbdmsId: obj.btbdmsId,
                        uprBtbdmsId: obj.uprBtbdmsId,
                        frstRegstId: obj.frstRegstId,
                        frstRgsrDtm: obj.frstRgsrDtm,
                        replyFileGrpUuid: obj.replyFileGrpUuid,
                    }));
                    setBtbdrpList(newBtbdrpList);
                    apiPostInfo.btbdrpList.forEach((obj: any, index: number) => {
                        form.btbdrpList[index]?.btbdrp.setValue("frstRegstId", obj.frstRegstId);
                        form.btbdrpList[index]?.btbdrp.setValue("frstRgsrDtm", obj.frstRgsrDtm);
                        form.btbdrpList[index]?.btbdrp.setValue("btbdmsCn", obj.btbdmsCn);
                        form.btbdrpList[index]?.btbdrp.setValue("btbdmsTtleNm", obj.btbdmsTtleNm);
                        form.btbdrpList[index]?.btbdrp.setValue("btbdmsId", obj.btbdmsId);
                        form.btbdrpList[index]?.btbdrp.setValue("replyFileGrpUuid", obj.replyFileGrpUuid);
                        form.btbdrpList[index]?.btbdrp.setSchema("btbdmsTtleNm", { required: false });
                        form.btbdrpList[index]?.btbdrp.setEditable(false);
                        setFormState((prevState) => [...prevState, false]);
                    });
                    setFormState((prevState) => [...prevState, true]);

                    // Commnets in the Reply Data Setting !== 답글의 댓글 정보 세팅 ==!
                    if (apiBrdInfo.btbdrpBtbdcmUseYn === "Y") {
                        apiPostInfo.btbdrpList.forEach((obj: any, idx: number) => {
                            const newRpCmList = obj.btbdcmList.map((inObj: any, inIdx: number) => ({
                                btbdcmSeq: inObj.btbdcmSeq,
                                btbdcmCn: inObj.btbdcmCn,
                                btbdmsId: inObj.btbdmsId,
                                frstRegstId: inObj.frstRegstId,
                                frstRgsrDtm: inObj.frstRgsrDtm,
                                editMode: false,
                            }));
                            setBtbdcmListByRp((prevState) => [...prevState, newRpCmList]);
                        });
                    }
                }
            },
        }),

        // Delete Bulletin board Management Information !== 게시글 삭제 ==!
        deleteBtbdmsInfo: useFetch({
            api: (bltbrdUuid, btbdmsId, from) => APIS.deleteBtbdmsInfo(bltbrdUuid, btbdmsId, from),
            onSuccess: (data) => {
                const from = data.from.content;
                modal.openModal({
                    content: "msg.com.00060", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    onCancel: () => {
                        if (from && from === "reply") {
                            location.reload(); // Screen Refresh
                        } else if (from === "main") {
                            navigate(`${URLS.ptli1018001q}?menuId=${menuId}&bltbrdUuid=${bltbrdUuid}`);
                        } else {
                            navigate(`${URLS.ptli1018001q}?menuId=${menuId}&bltbrdUuid=${bltbrdUuid}`);
                        }
                        navigate(`${URLS.ptli1018001q}?menuId=${menuId}&bltbrdUuid=${bltbrdUuid}`);
                    },
                });
            },
            onError: (e) => {
                console.log(e);
                modal.openModal({
                    content: e.response.data.errorMessage,
                });
            },
        }),

        // Save Bulletin board Reply !== 답변 등록 ==!
        registBtbdrpInfo: useFetch({
            api: (obj) => APIS.registBtbdmsInfo({ ...obj }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.00003", // Processed successfully. !== 성공적으로 처리 되었습니다. ==!
                    onCancel: () => {
                        navigate(`${URLS.ptli1018001q}?menuId=${menuId}&bltbrdUuid=${bltbrdUuid}`);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),

        // Save Bulletin board Reply !== 답변 수정 ==!
        modifyBtbdrpInfo: useFetch({
            api: (data: any) =>
                APIS.modifyBtbdmsInfo({
                    ...data,
                }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.00003", // Processed successfully. !== 성공적으로 처리 되었습니다. ==!
                    onCancel: () => {
                        location.reload();
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),

        // Save Bulletin board Comment !== 댓글 등록 ==!
        registBtbdcmInfo: useFetch({
            api: (btbdmsId, btbdcmCn) =>
                APIS.registBtbdcmInfo({
                    btbdmsId: btbdmsId,
                    btbdcmCn: btbdcmCn,
                }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.00003", // Processed successfully. !== 성공적으로 처리 되었습니다. ==!
                    onCancel: () => {
                        location.reload();
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),

        // Delete Bulletin board Management Information !== 댓글 삭제 ==!
        deleteBtbdcm: useFetch({
            api: (btbdmsId, seq) => APIS.deleteBtbdcmInfo(btbdmsId, seq),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00060", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    onCancel: () => {
                        location.reload(); // Screen Refresh
                    },
                });
            },
            onError: () => {},
        }),

        modifyBtbdrpSttsCd: useFetch({
            api: () =>
                APIS.modifyBtbdrpSttsCd({
                    bltbrdUuid: bltbrdUuid,
                    btbdmsId: btbdmsId,
                    btbdrpSttsCd: form.originBtbdms.getValue("btbdrpSttsCd"),
                }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.00003", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    onCancel: () => {
                        location.reload(); // Screen Refresh
                    },
                });
            },
            onError: () => {},
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.ptli1018001q}?menuId=${menuId}&bltbrdUuid=${bltbrdUuid}`),

        ppupYnChange: () => {
            const ppupYn = form.originBtbdms.getValue("ppupYn");
            if (comnUtils.isEmpty(ppupYn)) {
                setPpupYn(false);
            }
            if (ppupYn === "Y") {
                setPpupYn(true);
            } else {
                setPpupYn(false);
            }
            if (bltbrdUuid === "1860dd0c-b283-7cde-e063-020011ac3197") {
                setPpupYn(false);
                if (ppupYn === "Y") {
                    form.originBtbdms.setSchema("fileGrpUuid", { isPublic: true });
                } else {
                    form.originBtbdms.setSchema("fileGrpUuid", { isPublic: false });
                }
            }
        },

        onEditBtnClick: () => {
            navigate(
                `${URLS.ptli1018004s}/${bltbrdUuid}/${btbdmsId}?menuId=${menuId}&bltbrdUuid=${bltbrdUuid}&rpSize=${rpSize}`,
            );
        },

        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.00103", // Do you want to delete ? !== 삭제 하시겠습니까? ==!
                onConfirm: () => fetch.deleteBtbdmsInfo.fetch(bltbrdUuid, btbdmsId, "main"),
            });
        },
        onSubmitBtnClick: form.btbdrpList[btbdrpList?.length]?.btbdrp.handleSubmit(() => {
            let obj = form.btbdrpList[btbdrpList?.length]?.btbdrp.getValues();
            if (typeof obj.replyFileGrpUuid === "object") {
                obj.replyFileSaveDto = obj.replyFileGrpUuid;
                obj.replyFileGrpUuid = null;
            }
            obj.uprBtbdmsId = btbdmsId;
            obj.bltbrdUuid = bltbrdUuid;
            // form.btbdrpList[btbdrpList?.length].btbdrp.setValue("uprBtbdmsId", btbdmsId);
            // form.btbdrpList[btbdrpList?.length].btbdrp.setValue("bltbrdUuid", bltbrdUuid);
            modal.openModal({
                content: "msg.com.00047", // Confirm save? !== 저장하시겠습니까? ==!
                onConfirm: () => fetch.registBtbdrpInfo.fetch(obj),
            });
        }),

        onRpEditBtnClick: (index: number) => {
            form.btbdrpList[index].btbdrp.setSchema("btbdmsTtleNm", { required: true });
            form.btbdrpList[index].btbdrp.setEditable(true);
            setFormState((prevState) => {
                const newState = [...prevState];
                newState[index] = true;
                return newState;
            });
        },
        onRpDeleteBtnClick: (index: number) => {
            const btbdmsId = form.btbdrpList[index].btbdrp.getValues("btbdmsId");
            modal.openModal({
                content: "msg.00103", // Do you want to delete ? !== 삭제 하시겠습니까? ==!
                onConfirm: () => fetch.deleteBtbdmsInfo.fetch(bltbrdUuid, btbdmsId, "reply"),
            });
        },

        onRpSaveBtnClick: (index: number) => {
            // After changing the State value, run save !== State값 변경 이후, 저장 실행 ==!
            setModifyIdx(index);
        },

        RpSaveDataValid: form.btbdrpList[modifyIdx]?.btbdrp.handleSubmit(() => {
            form.btbdrpList[modifyIdx]?.btbdrp.setValue("uprBtbdmsId", btbdmsId);
            form.btbdrpList[modifyIdx]?.btbdrp.setValue("bltbrdUuid", bltbrdUuid);
            const data = form.btbdrpList[modifyIdx].btbdrp.getValues();
            delete data.frstRgsrDtm;
            delete data.lastMdfyDtm;
            if (typeof data.replyFileGrpUuid === "object") {
                data.replyFileSaveDto = data.replyFileGrpUuid;
                data.replyFileGrpUuid = null;
            }
            modal.openModal({
                content: "msg.com.00047", // Confirm save? !== 저장하시겠습니까? ==!
                onConfirm: () => fetch.modifyBtbdrpInfo.fetch(data),
            });
        }),

        onRpCancelBtnClick: (index: number) => {
            form.btbdrpList[index].btbdrp.setSchema("btbdmsTtleNm", { required: false });
            form.btbdrpList[index].btbdrp.setEditable(false);
            form.btbdrpList[index].btbdrp.setValue(
                "btbdmsCn",
                fetch.getBtbdmsInfo.data.resultMap.content.btbdmsInfo.btbdrpList[index].btbdmsCn,
            );
            setFormState((prevState) => {
                const newState = [...prevState];
                newState[index] = false;
                return newState;
            });
        },

        onCmSaveBtnClick: (type: any) => {
            if (typeof type === "number") {
                if (btbdcmCnByRp[type] === undefined) {
                    modal.openModal({
                        content: t("msg.com.00035", { 0: t("L_CMNT_CN") }), // Please enter {{0}}. !== {{0}} 을(를) 입력하여 주세요. ==!
                    });
                } else {
                    fetch.registBtbdcmInfo.fetch(btbdrpList[type].btbdmsId, btbdcmCnByRp[type]);
                }
            } else {
                if (btbdcmCn === undefined) {
                    modal.openModal({
                        content: t("msg.com.00035", { 0: t("L_CMNT_CN") }), // Please enter {{0}}. !== {{0}} 을(를) 입력하여 주세요. ==!
                    });
                } else {
                    fetch.registBtbdcmInfo.fetch(btbdmsId, btbdcmCn);
                }
            }
        },

        btbdcmCnChange: (value: any) => {
            setBtbdcmCn(value);
        },

        onCmDeleteBtnClick: (type: any, seq: any) => {
            if (typeof type === "number") {
                modal.openModal({
                    content: "msg.00103", // Do you want to delete ? !== 삭제 하시겠습니까? ==!
                    onConfirm: () => fetch.deleteBtbdcm.fetch(btbdrpList[type].btbdmsId, seq),
                });
            } else {
                modal.openModal({
                    content: "msg.00103", // Do you want to delete ? !== 삭제 하시겠습니까? ==!
                    onConfirm: () => fetch.deleteBtbdcm.fetch(btbdmsId, seq),
                });
            }
        },

        btbdRpcmCnChange: (index: any, value: any) => {
            setBtbdcmCnByRp((prevState) => {
                const newState = [...prevState];
                newState[index] = value;
                return newState;
            });
        },

        onStatusChangeClick: () => {
            fetch.modifyBtbdrpSttsCd.fetch();
        },
        // Click Apprvoal Re-Request Button !== 결재 재요청 버튼 클릭 ==!
        onAprvRqstBtnClick: () => {
            modal.openModal({
                url: "/comn/comn/ppup/aprvRqstPpup",
                params: {
                    bsopClsfCd: "PTL",
                    scrnDocCd: "scrn_ptla0005",
                    aprvReffId: `/${bltbrdUuid}/${btbdmsId}`,
                    rjctStatUseYn: "N",
                },
                size: "md",
                draggable: true,
                callback: (data) => {
                    // if (data.pgeUid === "ptli0409006s") {
                    modal.closeModal();
                    location.reload();
                    // }

                    // navigate(URLS.ptli0409004q);
                },
            });
        },
    };

    useEffect(() => {
        // Check bulletin board Message information !== 게시판 정보 조회==!
        fetch.getBtbdmsInfo.fetch();
        console.log(menuId);
    }, []);

    useEffect(() => {
        if (modifyIdx !== -1) {
            handler.RpSaveDataValid();
        }
    }, [modifyIdx]);

    useEffect(() => {
        fetch.getBtbdmsInfo.fetch();
    }, [theme]);

    return (
        <Page
            title={
                bltbrdInfo &&
                (lang === "ko"
                    ? bltbrdInfo.bltbrdKoNm
                    : lang === "en"
                      ? bltbrdInfo.bltbrdEngNm
                      : lang === "tz"
                        ? bltbrdInfo.bltbrdTzNm
                        : "")
            }
        >
            <Group>
                <Group.Header>
                    <Group.Title title={"L_BTBDMS"} />
                </Group.Header>
                <Group.Body>
                    {/* Main Bulletin board Message Start !== 메인 게시글 Start ==!*/}
                    <Group.Section>
                        {bltbrdInfo &&
                            [
                                "14270d90-17cd-e42d-e063-03001facae2d",
                                "153f6a94-797e-4255-e063-03001fac2587",
                                "14270d90-17be-e42d-e063-03001facae2d",
                            ].includes(bltbrdInfo.bltbrdUuid) && (
                                <Group.Row>
                                    <Group.Control {...form.originBtbdms.schema.reffKey} controlSize={10} />
                                </Group.Row>
                            )}
                        {bltbrdUuid === "1860dd0c-b283-7cde-e063-020011ac3197" && (
                            <Group.Row>
                                <Group.Control {...form.originBtbdms.schema.btbdmsId} controlSize={10} />
                            </Group.Row>
                        )}
                        <Group.Row>
                            <Group.Control {...form.originBtbdms.schema.btbdmsTtleNm} controlSize={10} />
                        </Group.Row>
                        {bltbrdInfo &&
                            bltbrdInfo.btbdmsTpCdValList &&
                            bltbrdInfo.btbdmsTpCdValList.map((obj: any, index: number) => {
                                return (
                                    <Group.Row key={index}>
                                        <Group.Control
                                            {...form.originBtbdms.schema[`btbdmsTpCd-${obj.btbdmsTpCd}-0`]}
                                        />
                                        {obj.usrDefnVldVal1 &&
                                            subCategory
                                                .filter((category: any) => category.comnCd === obj.usrDefnVldVal1)
                                                .map((category: any, _index: number) => (
                                                    <Group.Control
                                                        key={index + "-" + _index}
                                                        {...form.originBtbdms.schema[
                                                            `btbdmsTpCd-${obj.btbdmsTpCd}-${category.uprCdVldVal}`
                                                        ]}
                                                    />
                                                ))}
                                    </Group.Row>
                                );
                            })}
                        {bltbrdInfo &&
                            bltbrdInfo.bltbrdUuid === "2dc5aeb8-464f-2d48-e063-060011acac47" &&
                            aprvStatCd && (
                                <Group.Row>
                                    <Group.Control
                                        {...form.originBtbdms.schema.aprvStatCd}
                                        value={aprvStatCd}
                                        controlSize={10}
                                    />
                                </Group.Row>
                            )}
                        <Group.Row>
                            <Group.Control {...form.originBtbdms.schema.btbdmsCn} controlSize={10} />
                        </Group.Row>
                        {bltbrdInfo && bltbrdInfo.ppupSettPsblYn == "Y" && (
                            <Group.Row>
                                <Group.Control
                                    {...form.originBtbdms.schema.ppupYn}
                                    onChange={() => {
                                        handler.ppupYnChange();
                                    }}
                                />
                                {ppupYn && (
                                    <>
                                        <Group.Label label={t("L_PPUP_DATE")} size={2} />
                                        <Group.Col>
                                            <Group.Control {...form.originBtbdms.schema.ppupStrtDtm} controlSize={4} />
                                            <Group.Col size={2}>~</Group.Col>
                                            <Group.Control {...form.originBtbdms.schema.ppupEndDtm} controlSize={4} />
                                        </Group.Col>
                                    </>
                                )}
                            </Group.Row>
                        )}
                        {bltbrdInfo && bltbrdInfo.secrtBtbdmsUseYn == "Y" && (
                            <Group.Row>
                                <Group.Control {...form.originBtbdms.schema.secrtBtbdmsYn} />
                            </Group.Row>
                        )}
                        {/* Bulletin board Reply Status Management Start !== 답변상태관리 Start ==!*/}
                        {bltbrdInfo && bltbrdInfo.btbdrpSttsUseYn === "Y" && (
                            <Group.Row>
                                <Group.Control
                                    {...form.originBtbdms.schema.btbdrpSttsCd}
                                    edit={true}
                                    message={t("msg.ptl.00701")}
                                    onChange={handler.onStatusChangeClick}
                                />
                                {/* <Group.Col>
                                    <button
                                        data-color="blue"
                                        type="button"
                                        onClick={handler.onStatusChangeClick}
                                        className="max-w-full min-w-max flex justify-center items-center disabled:bg-uf-lightgray disabled:border-uf-lightgray disabled:pointer-events-none uf-button-outlined blue"
                                    >
                                        {t("B_ANSWR_STTS_CHANGE")}
                                    </button>
                                </Group.Col> */}
                            </Group.Row>
                        )}
                        {/* Bulletin board Reply Status Management Start !== 답변상태관리 End ==!*/}
                        {/* {bltbrdInfo && bltbrdInfo.btbdrpSttsUseYn == "Y" && (
                            <Group.Row>
                                <Group.Control
                                    {...form.originBtbdms.schema.btbdrpSttsCd}
                                    value={fetch.getBtbdmsInfo.data?.resultMap.content.btbdmsInfo.btbdrpSttsCd}
                                />
                            </Group.Row>
                        )} */}
                        {bltbrdInfo && bltbrdInfo.atcmUseYn == "Y" && (
                            <Group.Row>
                                <Group.Control {...form.originBtbdms.schema.fileGrpUuid} controlSize={10} />
                            </Group.Row>
                        )}
                    </Group.Section>
                    {/* Main Bulletin board Message Start !== 메인 게시글 End ==!*/}
                    {/* Main Bulletin board Comment Start !== 댓글 Start ==!*/}
                    {bltbrdInfo && bltbrdInfo.btbdcmUseYn === "Y" && (
                        <>
                            <Table key="comment">
                                {btbdcmList &&
                                    btbdcmList?.length !== 0 &&
                                    btbdcmList.map((btbdcmItem, index) => (
                                        <Table.Tr key={btbdcmItem.btbdcmSeq}>
                                            <Table.Th width={"16.5%"}>
                                                {btbdcmItem.frstRegstId} (
                                                {dayjs(btbdcmItem.frstRgsrDtm).format(dateTimeFormat)})
                                            </Table.Th>
                                            <Table.Td>
                                                <Group.Control
                                                    type="textarea"
                                                    edit={btbdcmItem.editMode}
                                                    value={btbdcmItem.btbdcmCn}
                                                />
                                            </Table.Td>
                                            {auth.get("usrId") === btbdcmItem.frstRegstId && (
                                                <Table.Td width={"5%"}>
                                                    <IconButton
                                                        icon="close"
                                                        size="xs"
                                                        onClick={handler.onCmDeleteBtnClick.bind(
                                                            null,
                                                            "m",
                                                            btbdcmItem.btbdcmSeq,
                                                        )}
                                                    />
                                                </Table.Td>
                                            )}
                                        </Table.Tr>
                                    ))}
                            </Table>
                            {menuId !== "elecAprv" && (
                                <Table>
                                    <Table.Tr key="cmDefault">
                                        <Table.Th width={"16.5%"}>
                                            {auth.get("usrId")} ({dayjs(new Date()).format(dateFormat)})
                                        </Table.Th>
                                        <Table.Td>
                                            <Group.Control
                                                type="textarea"
                                                value={btbdcmCn}
                                                onChange={handler.btbdcmCnChange}
                                            />
                                        </Table.Td>
                                        <Table.Td width={"5%"}>
                                            <Layout>
                                                <Layout.Left>
                                                    <Layout.Button
                                                        role={"submit"}
                                                        onClick={() => handler.onCmSaveBtnClick("m")}
                                                    />
                                                </Layout.Left>
                                            </Layout>
                                        </Table.Td>
                                    </Table.Tr>
                                </Table>
                            )}
                        </>
                    )}
                    {/* Main Bulletin board Comment Start !== 댓글 End ==!*/}
                </Group.Body>
            </Group>
            {bltbrdInfo &&
                [
                    "14270d90-17cd-e42d-e063-03001facae2d",
                    "153f6a94-797e-4255-e063-03001fac2587",
                    "14270d90-17be-e42d-e063-03001facae2d",
                ].includes(bltbrdInfo.bltbrdUuid) && (
                    <Group>
                        <Group.Header>
                            <Group.Title title={"T_BTBDMS_INT"} />
                        </Group.Header>
                        <Group.Body>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.originBtbdms.schema.btbdmsIntCn} controlSize={10} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.originBtbdms.schema.intFileGrpUuid} controlSize={10} />
                                </Group.Row>
                            </Group.Section>
                        </Group.Body>
                    </Group>
                )}
            {/* Bulletin board Reply Start !== 답글 Start ==!*/}
            {bltbrdInfo && bltbrdInfo.btbdrpUseYn === "Y" && bltbrdInfo.btbdrpSelcExuseYn !== "Y" && (
                <>
                    {btbdrpList &&
                        btbdrpList?.length !== 0 &&
                        btbdrpList.map((btbdrpItem, index) => (
                            <Group key={index}>
                                <Group.Header>
                                    <Layout direction="row">
                                        <Layout.Left>
                                            <Group.Title title={"L_BTBDRP"}></Group.Title>
                                        </Layout.Left>
                                        {bltbrdInfo &&
                                            bltbrdInfo.btbdrpSelcExuseYn !== "Y" &&
                                            auth.get("usrId") === btbdrpItem.frstRegstId && (
                                                <Layout.Right>
                                                    {formState.length > index &&
                                                        (formState[index] ? (
                                                            <>
                                                                <Layout.Button
                                                                    role={"cancel"}
                                                                    onClick={() => handler.onRpCancelBtnClick(index)}
                                                                />
                                                                <Layout.Button
                                                                    role={"submit"}
                                                                    onClick={() => handler.onRpSaveBtnClick(index)}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Layout.Button
                                                                    role={"edit"}
                                                                    onClick={() => handler.onRpEditBtnClick(index)}
                                                                />
                                                                <Layout.Button
                                                                    role={"delete"}
                                                                    onClick={() => handler.onRpDeleteBtnClick(index)}
                                                                />
                                                            </>
                                                        ))}
                                                </Layout.Right>
                                            )}
                                    </Layout>
                                </Group.Header>
                                <Group.Body>
                                    <Group.Section>
                                        <Group.Row>
                                            <Group.Control
                                                {...form.btbdrpList[index]?.btbdrp.schema.frstRegstId}
                                                readOnly={true}
                                            />
                                            <Group.Control
                                                {...form.btbdrpList[index]?.btbdrp.schema.frstRgsrDtm}
                                                readOnly={true}
                                                type="date"
                                            />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control
                                                {...form.btbdrpList[index]?.btbdrp.schema.btbdmsTtleNm}
                                                controlSize={10}
                                            />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control
                                                {...form.btbdrpList[index]?.btbdrp.schema.btbdmsCn}
                                                controlSize={10}
                                            />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control
                                                {...form.btbdrpList[index]?.btbdrp.schema.replyFileGrpUuid}
                                                controlSize={10}
                                            />
                                        </Group.Row>
                                    </Group.Section>
                                    {/* Main Bulletin board Comment In Reply Detail Start !== 답글의 댓글 Detail Start ==!*/}
                                    {bltbrdInfo && bltbrdInfo.btbdrpBtbdcmUseYn === "Y" && (
                                        <Table key="commentInReply">
                                            {btbdcmListByRp &&
                                                btbdcmListByRp?.length !== 0 &&
                                                btbdcmListByRp[index].map((rpCmItem, inIndx) => (
                                                    <Table.Tr key={rpCmItem?.btbdcmSeq}>
                                                        <Table.Th width={"16.5%"}>
                                                            {rpCmItem.frstRegstId} (
                                                            {dayjs(rpCmItem.frstRgsrDtm).format(dateTimeFormat)})
                                                        </Table.Th>
                                                        <Table.Td>
                                                            <Group.Control
                                                                type="textarea"
                                                                edit={rpCmItem.editMode}
                                                                value={rpCmItem.btbdcmCn}
                                                            />
                                                        </Table.Td>
                                                        {auth.get("usrId") === rpCmItem.frstRegstId && (
                                                            <Table.Td width={"5%"}>
                                                                <IconButton
                                                                    icon="close"
                                                                    size="xs"
                                                                    onClick={handler.onCmDeleteBtnClick.bind(
                                                                        null,
                                                                        index,
                                                                        rpCmItem.btbdcmSeq,
                                                                    )}
                                                                />
                                                            </Table.Td>
                                                        )}
                                                    </Table.Tr>
                                                ))}
                                        </Table>
                                    )}
                                    {/* Main Bulletin board Comment In Reply Detail End !== 답글의 댓글 Detail End ==!*/}
                                    {/* Main Bulletin board Comment In Reply Form Start !== 답글의 댓글 Form Start ==!*/}
                                    {bltbrdInfo && (
                                        <Table key="replyComment">
                                            <Table.Tr key="rpCmDefault">
                                                <Table.Th width={"16.5%"}>
                                                    {auth.get("usrId")} ({dayjs(new Date()).format(dateFormat)})
                                                </Table.Th>
                                                <Table.Td>
                                                    <Group>
                                                        <Group.Control
                                                            type="textarea"
                                                            value={btbdcmCnByRp[index]}
                                                            onChange={handler.btbdRpcmCnChange.bind(null, index)}
                                                        />
                                                    </Group>
                                                </Table.Td>
                                                <Table.Td width={"5%"}>
                                                    <Layout>
                                                        <Layout.Left>
                                                            <Layout.Button
                                                                role={"submit"}
                                                                onClick={() => handler.onCmSaveBtnClick(index)}
                                                            />
                                                        </Layout.Left>
                                                    </Layout>
                                                </Table.Td>
                                            </Table.Tr>
                                        </Table>
                                    )}
                                    {/* Main Bulletin board Comment In Reply Form End !== 답글의 댓글 Form End ==!*/}
                                </Group.Body>
                            </Group>
                        ))}
                    {/* Main Bulletin board Reply Form Start !== 답글 Form Start ==!*/}
                    {bltbrdInfo && bltbrdInfo.btbdrpSelcExuseYn !== "Y" && (
                        <Group key="rpForm">
                            <Group.Header>
                                <Layout direction="row">
                                    <Layout.Left>
                                        <Group.Title title={"L_BTBDRP"}></Group.Title>
                                    </Layout.Left>
                                    <Layout.Right>
                                        <Layout.Button role={"submit"} onClick={() => handler.onSubmitBtnClick()} />
                                    </Layout.Right>
                                </Layout>
                            </Group.Header>
                            <Group.Body>
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control
                                            {...form.btbdrpList[btbdrpList?.length]?.btbdrp.schema.frstRegstId}
                                            readOnly={true}
                                            value={auth.get("usrId")}
                                        />
                                        <Group.Control
                                            {...form.btbdrpList[btbdrpList?.length]?.btbdrp.schema.frstRgsrDtm}
                                            readOnly={true}
                                            type="date"
                                        />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control
                                            {...form.btbdrpList[btbdrpList?.length]?.btbdrp.schema.btbdmsTtleNm}
                                            controlSize={10}
                                        />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control
                                            {...form.btbdrpList[btbdrpList?.length]?.btbdrp.schema.btbdmsCn}
                                            controlSize={10}
                                        />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control
                                            {...form.btbdrpList[btbdrpList?.length]?.btbdrp.schema.replyFileGrpUuid}
                                            controlSize={10}
                                        />
                                    </Group.Row>
                                </Group.Section>
                            </Group.Body>
                        </Group>
                    )}
                    {/* Main Bulletin board Reply Form End !== 답글 Form End ==!*/}
                </>
            )}
            {/* Bulletin board Reply End !== 답글 End ==!*/}
            <Layout direction="row" key="default">
                {menuId !== "elecAprv" && (
                    <>
                        <Layout.Left>
                            <Layout.Button role={"list"} onClick={() => handler.onListBtnClick()} />
                        </Layout.Left>
                        <Layout.Right>
                            {bltbrdInfo &&
                                bltbrdInfo.bltbrdUuid === "2dc5aeb8-464f-2d48-e063-060011acac47" &&
                                !aprvStatCd &&
                                auth.get("usrId") === form.originBtbdms.getValue("frstRegstId") && (
                                    <Layout.Button variant="primary" onClick={handler.onAprvRqstBtnClick}>
                                        {t("B_APRV_RQST")}
                                    </Layout.Button>
                                )}
                            {bltbrdInfo && bltbrdInfo.chgYn === "Y" && !aprvStatCd && (
                                <>
                                    {(auth.get("usrId") === form.originBtbdms.getValue("frstRegstId") ||
                                        isBmsMstrUser.current ||
                                        bltbrdUuid == "14270d90-17cd-e42d-e063-03001facae2d") && (
                                        <Layout.Button role={"apply"} onClick={() => handler.onEditBtnClick()}>
                                            {t("B_NEXT")}
                                        </Layout.Button>
                                    )}
                                    {bltbrdInfo.btbdmsSelcExuseYn !== "Y" &&
                                        auth.get("usrId") === form.originBtbdms.getValue("frstRegstId") && (
                                            <Layout.Button role={"delete"} onClick={() => handler.onDeleteBtnClick()} />
                                        )}
                                </>
                            )}
                        </Layout.Right>
                    </>
                )}
            </Layout>
        </Page>
    );
};
